import React from "react";
import Header from "./Header";
import AboutUsSection from "./AboutUsSection";
import PresenceStats from "./PresenceStats";
import RealExamSimulations from "./RealExamSimulations";
import WhyChooseUs from "./WhyChooseUs";
import Note from "./Note";

function Home() {
  return (
    <>
      <Header />
      <PresenceStats />
      <AboutUsSection />
      <RealExamSimulations />
      <WhyChooseUs />
      <Note />
    </>
  );
}

export default Home;
